'use strict';
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPromise = isPromise;
function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/util/isPromise.js
// module id = 157
// module chunks = 177